define('lq/events/actions/addToHomeScreenCommand',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq/services/mpa/addToHomeScreenCommand',
    'lq/services/action/addToHomeScreenCommand'
], function (_, EventAction, AddToHomeScreenCommandMpa, AddToHomeScreenCommandSpa) {
    'use strict';

    function AddToHomeScreenCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;

        if (AddToHomeScreenCommandMpa.deferredPrompt) {
            this.deferredPrompt = AddToHomeScreenCommandMpa.deferredPrompt;

        } else if (AddToHomeScreenCommandSpa.deferredPrompt) {
            this.deferredPrompt = AddToHomeScreenCommandSpa.deferredPrompt;
        }

        return this;
    }

    AddToHomeScreenCommand.prototype.deferredPrompt = null

    EventAction.extend(AddToHomeScreenCommand, EventAction);

    AddToHomeScreenCommand.typeName = 'AddToHomeScreenCommand';

    AddToHomeScreenCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    AddToHomeScreenCommand.prototype.execute = function (continuation) {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            if (this.eventIsEnabled('installationPrompted')) {
                this.triggerEvent('installationPrompted');
            }
            this.deferredPrompt.userChoice.then(function (result) {
                if (result.outcome === 'accepted') {
                    this.deferredPrompt = null;
                }
            });
        }
        continuation();
    };

    return AddToHomeScreenCommand;
});

